import { appearanceCollection } from '@/constants/appearanceList'

export default ({ appearanceId }) => appearanceCollection[appearanceId].name
